import axios from 'axios';
import { apiBaseUrl } from '../config';

export function createPaymentOrder(token, courseId) {
  return axios.post(
    `${apiBaseUrl}/user/courses/payment/order`,
    { courseId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }
  );
}

export function verifyPayment(token, payload) {
  return axios.post(
    `${apiBaseUrl}/user/courses/payment/verify`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      withCredentials: true
    }
  );
}
